// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clinical-main:has(.set-page),
.clinical-main__scroll:has(.set-page) {
  background: #f8fafc;
}

.clinical-main:has(.intg),
.clinical-main__scroll:has(.intg),
.clinical-main:has(.dsch),
.clinical-main__scroll:has(.dsch) {
  background: #fff;
}

.set-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
  min-height: 100%;
  padding: 28px 32px 48px;
  background: #f8fafc;
  color: #0f172a;
}

.set-page:has(.intg),
.set-page:has(.dsch) {
  background: #fff;
}

.set-page__head h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.set-page__head p {
  margin: 6px 0 0;
  max-width: 640px;
  font-size: 14px;
  line-height: 1.5;
  color: #64748b;
}

.set-page__body .form-part {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
}

.set-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.set-card__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 13px;
}

.set-primary.ant-btn {
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: #0ea5e9;
  color: #fff;
  font-weight: 600;
}

.set-primary.ant-btn:hover {
  background: #0284c7 !important;
  color: #fff !important;
}

.set-table-wrap {
  overflow-x: auto;
}

.set-table {
  width: 100%;
  border-collapse: collapse;
}

.set-table th {
  padding: 12px 18px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-align: start;
  text-transform: uppercase;
}

.set-table td {
  padding: 14px 18px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  font-size: 14px;
}

.set-table tr:last-child td {
  border-bottom: 0;
}

.set-name {
  font-weight: 600;
  color: #0f172a;
}

.set-empty {
  padding: 28px 18px;
  color: #94a3b8;
  text-align: center;
}

.intg {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.intg-head h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.intg-head p {
  margin: 4px 0 0;
  max-width: 640px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.intg-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.intg-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.intg-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
}

.intg-tab:hover {
  background: #f1f5f9;
}

.intg-tab.is-active {
  background: #0ea5e9;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);
}

.intg-tab__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #334155;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 10px;
  font-weight: 600;
}

.intg-tab.is-active .intg-tab__count {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.intg-search {
  position: relative;
  display: flex;
  align-items: center;
  width: min(240px, 100%);
  height: 32px;
  padding: 0 10px 0 32px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.intg-search svg {
  position: absolute;
  left: 10px;
  color: #94a3b8;
  pointer-events: none;
}

.intg-search input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: #0f172a;
  font-size: 12px;
}

.intg-search input::placeholder {
  color: #94a3b8;
}

.intg-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.intg-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: box-shadow 0.15s ease;
}

.intg-card:hover {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.intg-card__accent {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  background: #cbd5e1;
}

.intg-card.is-connected .intg-card__accent {
  background: #059669;
}

.intg-card__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 20px 16px 24px;
}

.intg-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.intg-card__identity {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.intg-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f1f5f9;
  color: #64748b;
}

.intg-card.is-connected .intg-card__icon {
  border-color: #dcfce7;
  background: #f0fdf4;
  color: #059669;
}

.intg-card__identity h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
  line-height: 1.3;
}

.intg-card__protocol {
  display: block;
  margin-top: 2px;
  color: #64748b;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  line-height: 1.35;
}

.intg-card__desc {
  margin: 0;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.intg-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

.intg-status.is-on {
  background: #ecfdf5;
  color: #059669;
}

.intg-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #94a3b8;
}

.intg-status.is-on .intg-status__dot {
  background: #059669;
}

.intg-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  color: #475569;
}

.intg-meta__item {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}

.intg-meta__item > span {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}

.intg-meta__item strong {
  overflow-wrap: anywhere;
  font-weight: 600;
  color: #0f172a;
}

.intg-meta__item strong.is-ok {
  color: #059669;
}

.intg-meta__key {
  max-width: 220px;
}

.intg-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 20px 16px 24px;
  border-top: 1px solid #f1f5f9;
}

.intg-card__foot-note {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #64748b;
  font-size: 12px;
}

.intg-card__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-inline-start: auto;
}

.intg-ghost,
.intg-manage {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.intg-ghost {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.03);
}

.intg-ghost:hover {
  background: #f8fafc;
}

.intg-manage {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.03);
}

.intg-manage:hover {
  background: #f8fafc;
}

.intg-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  text-align: center;
}

.intg-empty__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 4px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #94a3b8;
}

.intg-empty h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.intg-empty p {
  margin: 0;
  max-width: 360px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.intg-empty .intg-ghost {
  margin-top: 8px;
}

@media (max-width: 900px) {
  .intg-grid {
    grid-template-columns: 1fr;
  }

  .intg-search {
    width: 100%;
  }

  .intg-card__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .intg-card__actions {
    margin-inline-start: 0;
  }

  .intg-ghost,
  .intg-manage {
    flex: 1;
    justify-content: center;
  }
}

.dsch {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dsch-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.dsch-title {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.dsch-title__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-top: 2px;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0ea5e9;
}

.dsch-title h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.dsch-title p {
  margin: 4px 0 0;
  max-width: 640px;
  color: #475569;
  font-size: 13px;
  line-height: 1.45;
}

.dsch-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.dsch-add:hover {
  background: #f8fafc;
}

.dsch-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.dsch-field {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: min(280px, 100%);
  flex: 1;
}

.dsch-field > span {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.dsch-field select {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.dsch-field select:focus {
  outline: none;
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);
}

.dsch-panel {
  overflow: hidden;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.dsch-panel__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 18px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.dsch-panel__title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0ea5e9;
}

.dsch-panel__title h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.dsch-panel__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  background: #ecfdf5;
  color: #059669;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.dsch-panel__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #10b981;
}

.dsch-table-wrap {
  overflow-x: auto;
}

.dsch-table {
  width: 100%;
  border-collapse: collapse;
}

.dsch-table th {
  padding: 10px 14px;
  border-bottom: 1px solid #e2e8f0;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: start;
  text-transform: uppercase;
  white-space: nowrap;
}

.dsch-table td {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  color: #0f172a;
  font-size: 13px;
  vertical-align: middle;
  white-space: nowrap;
}

.dsch-table tbody tr:hover {
  background: #f8fafc;
}

.dsch-table tbody tr:last-child td {
  border-bottom: 0;
}

.dsch-strong {
  font-weight: 600;
}

.dsch-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
}

.dsch-day {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.dsch-day__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;
}

.dsch-day__dot.is-on {
  background: #0ea5e9;
}

.dsch-shift {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  background: #eff6ff;
  color: #0284c7;
  font-size: 11px;
  font-weight: 600;
}

.dsch-pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.dsch-pill.is-on {
  background: #ecfdf5;
  color: #059669;
}

.dsch-table__actions {
  text-align: end;
}

.dsch-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.dsch-edit:hover {
  background: #f1f5f9;
  color: #0ea5e9;
}

.dsch-empty {
  padding: 36px 18px !important;
  color: #94a3b8;
  text-align: center;
  white-space: normal !important;
}

.dsch-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 18px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  font-size: 12px;
}

.dsch-pager__controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dsch-pager__controls button {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.dsch-pager__controls button:hover:not(:disabled) {
  background: #f8fafc;
}

.dsch-pager__controls button:disabled {
  color: #cbd5e1;
  cursor: default;
}

@media (max-width: 900px) {
  .dsch-field {
    flex-direction: column;
    align-items: stretch;
    min-width: 100%;
  }
}

.usr-head {
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.usr-crumb {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
}

.usr-crumb__current {
  color: #0ea5e9;
  font-weight: 600;
}

.usr-title {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.usr-title h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.usr-title span {
  padding: 4px 10px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 12px;
  font-weight: 500;
}

.usr-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 20px 0 16px;
}

.usr-search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(320px, 100%);
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #94a3b8;
}

.usr-search input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: #0f172a;
  font-size: 12px;
}

.usr-search:focus-within {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);
}

.usr-export {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.usr-export:hover {
  background: #f8fafc;
}

.usr-export svg {
  color: #64748b;
}

.usr-table tbody tr:hover td {
  background: #f8fafc;
}

.usr-id {
  color: #64748b;
  font-variant-numeric: tabular-nums;
}

.usr-person {
  display: flex;
  align-items: center;
  gap: 12px;
}

.usr-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #bae6fd;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.usr-person strong,
.usr-person em {
  display: block;
}

.usr-person strong {
  color: #0f172a;
  font-size: 13px;
}

.usr-person em {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 11px;
  font-style: normal;
}

.usr-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  color: #64748b;
  font-size: 12px;
}

.usr-pager div {
  display: flex;
  align-items: center;
  gap: 4px;
}

.usr-pager button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.usr-pager button:hover:not(:disabled) {
  background: #f1f5f9;
}

.usr-pager button.is-current {
  background: #0ea5e9;
  color: #fff;
}

.usr-pager button:disabled {
  background: #f1f5f9;
  color: #cbd5e1;
  cursor: default;
}

.job-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.job-head h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.job-head p {
  margin: 4px 0 0;
  max-width: 560px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.job-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: #0ea5e9;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.job-add:hover {
  background: #0284c7;
}

.job-add:disabled {
  background: #94a3b8;
  cursor: default;
}

.job-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0 16px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.job-select {
  position: relative;
  width: 190px;
}

.job-select select {
  width: 100%;
  height: 36px;
  padding: 0 28px 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 12px;
  appearance: none;
}

.job-select svg {
  position: absolute;
  top: 10px;
  inset-inline-end: 8px;
  color: #94a3b8;
  pointer-events: none;
}

.job-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #0f172a;
  font-weight: 600;
}

.job-title i {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #0ea5e9;
}

.job-role {
  display: inline-flex;
  padding: 2px 10px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 11px;
  font-weight: 600;
}

.job-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
}

.job-pager div {
  display: flex;
  align-items: center;
  gap: 6px;
}

.job-pager button,
.job-pager .is-current {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}

.job-pager button {
  cursor: pointer;
}

.job-pager button:disabled {
  color: #cbd5e1;
  cursor: default;
}

.job-pager .is-current {
  border-color: #0ea5e9;
  background: #0ea5e9;
  color: #fff;
}

.rxset {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.rxset-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.rxset-head h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.rxset-preview-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.rxset-preview-btn:hover {
  background: #f8fafc;
}

.rxset-layout {
  display: grid;
  grid-template-columns: minmax(280px, 5fr) minmax(0, 7fr);
  gap: 24px;
  align-items: start;
}

.rxset-controls {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.rxset-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.rxset-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
}

.rxset-card__head h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.rxset-card__lucide {
  flex-shrink: 0;
  color: #0284c7;
}

.rxset-margins {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.rxset-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rxset-field > span {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.rxset-field small {
  font-size: 11px;
  line-height: 1.4;
  color: #64748b;
}

.rxset-field__input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
}

.rxset-field__input:focus-within {
  border-color: #0284c7;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);
}

.rxset-field__input input {
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
}

.rxset-field__input span {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.rxset-field__input--sm {
  width: 80px;
  flex-shrink: 0;
  padding: 4px 10px;
}

.rxset-field__input--sm input {
  text-align: right;
}

.rxset-font {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rxset-font__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.rxset-font__row > span:first-child {
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.rxset-font__badge {
  padding: 2px 8px;
  border-radius: 4px;
  background: #e0f2fe;
  color: #0284c7;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
}

.rxset-font__controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rxset-font__controls input[type='range'] {
  flex: 1;
  height: 6px;
  accent-color: #0ea5e9;
  cursor: pointer;
}

.rxset-font p {
  margin: 0;
  font-size: 11px;
  line-height: 1.4;
  color: #64748b;
}

.rxset-font__rule {
  height: 1px;
  background: #f1f5f9;
}

.rxset-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.rxset-reset,
.rxset-save {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.rxset-reset {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}

.rxset-reset:hover {
  background: #f8fafc;
}

.rxset-save {
  border: 0;
  background: #0ea5e9;
  color: #fff;
}

.rxset-save:hover:not(:disabled) {
  background: #0284c7;
}

.rxset-save:disabled {
  background: #94a3b8;
  cursor: default;
}

.rxset-preview {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px 20px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.rxset-preview__bar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rxset-preview__title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rxset-preview__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #10b981;
  flex-shrink: 0;
}

.rxset-preview__title h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.rxset-preview__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.rxset-preview__meta span:first-child {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
}

.rxset-preview__meta span:last-child {
  font-size: 12px;
  color: #64748b;
}

.rxset-preview__stage {
  /* Paper preview uses physical LTR coords (margins + scale origin). */
  direction: ltr;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 28px 24px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.rxset-ruler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 560px;
  gap: 8px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 10px;
  color: #64748b;
}

.rxset-ruler__line {
  position: relative;
  flex: 1;
  height: 1px;
  margin: 0 4px;
  background: #cbd5e1;
}

.rxset-ruler__line span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 0 8px;
  background: #f8fafc;
  color: #475569;
  white-space: nowrap;
}

.rxset-preview__tip {
  margin: 0;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.rxset-sheet-scale {
  position: relative;
  direction: ltr;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  background: #e2e8f0;
}

.rxset-sheet {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background:
    repeating-linear-gradient(
      -45deg,
      #f8fafc,
      #f8fafc 6px,
      #f1f5f9 6px,
      #f1f5f9 12px
    );
  transition: padding 0.15s ease;
  transform-origin: top left;
}

.rxset-sheet__body {
  flex: 1;
  min-height: 0;
  padding: 8px;
  background: #fff;
  border: 1px dashed #cbd5e1;
  box-sizing: border-box;
}

.rxset-sheet__body.is-rtl {
  direction: rtl;
  text-align: right;
}

.rxset-print-host {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.rxset-print-root {
  width: 210mm;
  background: #fff;
  color: #000;
}

.rxset-preview__stats {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  width: 100%;
  max-width: 560px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  color: #64748b;
}

.rxset-preview__stats span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.rxset-preview__stats i {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: #0284c7;
}

.rxset-preview__stats i.is-muted {
  background: #cbd5e1;
}

@media (max-width: 1100px) {
  .rxset-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .rxset-margins {
    grid-template-columns: 1fr;
  }

  .rxset-head {
    flex-direction: column;
  }

  .rxset-actions {
    flex-direction: column-reverse;
  }

  .rxset-reset,
  .rxset-save {
    width: 100%;
    justify-content: center;
  }
}

.acct-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.acct-crumb {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
}

.acct-crumb__current {
  color: #0ea5e9;
  font-weight: 600;
}

.acct-head h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.acct-save {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 6px;
  width: fit-content;
  height: 36px;
  padding: 0 16px;
  border: 0;
  border-radius: 8px;
  background: #0ea5e9;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.acct-save:hover:not(:disabled) {
  background: #0284c7;
}

.acct-save:disabled {
  opacity: 0.45;
  cursor: default;
}

.acct-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.acct-main,
.acct-side {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.acct-card {
  padding: 20px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.acct-card__head,
.acct-onboard {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.acct-card__head {
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.acct-icon {
  flex-shrink: 0;
  margin-top: 2px;
  color: #0ea5e9;
}

.acct-card h2,
.acct-onboard h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.acct-card__head p,
.acct-onboard span,
.acct-card small,
.acct-panel p,
.acct-onboard__body,
.acct-onboard__empty {
  margin: 2px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.acct-fields {
  display: grid;
  gap: 16px;
}

.acct-fields--split {
  grid-template-columns: 1fr 1fr;
}

.acct-card label {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.acct-card label > span,
.acct-email > span {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
}

.acct-input,
.acct-input.ant-input-affix-wrapper {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 12px;
  box-sizing: border-box;
}

.acct-input:focus,
.acct-input.ant-input-affix-wrapper-focused {
  background: #fff;
  border-color: #0ea5e9;
  outline: none;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);
}

.acct-input[readonly] {
  color: #0f172a;
}

.acct-readonly {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f1f5f9;
}

.acct-readonly strong {
  overflow: hidden;
  color: #0f172a;
  font-size: 12px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.acct-readonly em {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 6px;
  background: #e2e8f0;
  color: #475569;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}

.acct-email {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 16px;
}

.acct-email__row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.acct-ghost,
.acct-onboard__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.acct-ghost {
  flex-shrink: 0;
  align-self: flex-start;
  width: fit-content;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0ea5e9;
}

.acct-ghost:hover,
.acct-onboard__action:hover {
  background: #f0f9ff;
}

.acct-panel {
  margin-top: 12px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.acct-panel__title {
  color: #0f172a;
  font-size: 12px;
  font-weight: 600;
}

.acct-panel .acct-input {
  margin-top: 8px;
  background: #fff;
}

.acct-strength {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
}

.acct-strength__bars {
  display: flex;
  gap: 4px;
  width: 160px;
}

.acct-strength__bars i {
  flex: 1;
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
}

.acct-strength__bars.is-1 i:nth-child(-n + 1) { background: #f43f5e; }
.acct-strength__bars.is-2 i:nth-child(-n + 2) { background: #f59e0b; }
.acct-strength__bars.is-3 i:nth-child(-n + 3) { background: #0ea5e9; }
.acct-strength__bars.is-4 i { background: #10b981; }

.acct-strength em {
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
}

.acct-strength__bars.is-1 + em { color: #f43f5e; }
.acct-strength__bars.is-2 + em { color: #d97706; }
.acct-strength__bars.is-3 + em { color: #0284c7; }
.acct-strength__bars.is-4 + em { color: #10b981; }

.acct-match {
  color: #10b981 !important;
  font-weight: 500;
}

.acct-error {
  color: #e11d48 !important;
}

.acct-select {
  position: relative;
}

.acct-select select {
  width: 100%;
  height: 36px;
  padding: 0 32px 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 12px;
  appearance: none;
}

.acct-select svg {
  position: absolute;
  top: 9px;
  inset-inline-end: 10px;
  color: #64748b;
  pointer-events: none;
}

.acct-onboard {
  margin-bottom: 12px;
}

.acct-onboard__mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: #e0f2fe;
  color: #0ea5e9;
  flex-shrink: 0;
}

.acct-onboard span {
  display: block;
  color: #0ea5e9;
  font-weight: 600;
}

.acct-onboard__body {
  margin: 0 0 14px;
}

.acct-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  line-height: 1.4;
}

.acct-note svg {
  flex-shrink: 0;
  color: #0ea5e9;
}

.acct-onboard__action {
  width: 100%;
  border: 1px solid #bae6fd;
  background: #f0f9ff;
  color: #0284c7;
}

.acct-tours {
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
}

.acct-tours li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid #f1f5f9;
}

.acct-tours strong,
.acct-tours span {
  display: block;
}

.acct-tours strong {
  color: #0f172a;
  font-size: 12px;
}

.acct-tours span {
  margin-top: 2px;
  color: #64748b;
  font-size: 11px;
}

.acct-tours button {
  flex-shrink: 0;
  border: 0;
  background: transparent;
  color: #0284c7;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 1100px) {
  .acct-grid,
  .acct-fields--split,
  .acct-email__row {
    grid-template-columns: 1fr;
  }

  .acct-email__row,
  .acct-head {
    flex-direction: column;
    align-items: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/style.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,6EAA6E;EAC7E,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6EAA6E;EAC7E,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,OAAO;IACP,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qEAAqE;EACrE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,6EAA6E;EAC7E,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB;;;;;;;KAOG;EACH,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,6EAA6E;EAC7E,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,gDAAgD,mBAAmB,EAAE;AACrE,gDAAgD,mBAAmB,EAAE;AACrE,gDAAgD,mBAAmB,EAAE;AACrE,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;;AAEjD;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".clinical-main:has(.set-page),\n.clinical-main__scroll:has(.set-page) {\n  background: #f8fafc;\n}\n\n.clinical-main:has(.intg),\n.clinical-main__scroll:has(.intg),\n.clinical-main:has(.dsch),\n.clinical-main__scroll:has(.dsch) {\n  background: #fff;\n}\n\n.set-page {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  box-sizing: border-box;\n  min-height: 100%;\n  padding: 28px 32px 48px;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.set-page:has(.intg),\n.set-page:has(.dsch) {\n  background: #fff;\n}\n\n.set-page__head h1 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.set-page__head p {\n  margin: 6px 0 0;\n  max-width: 640px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.set-page__body .form-part {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n}\n\n.set-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.set-card__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.set-primary.ant-btn {\n  height: 36px;\n  padding: 0 14px;\n  border: 0;\n  border-radius: 8px;\n  background: #0ea5e9;\n  color: #fff;\n  font-weight: 600;\n}\n\n.set-primary.ant-btn:hover {\n  background: #0284c7 !important;\n  color: #fff !important;\n}\n\n.set-table-wrap {\n  overflow-x: auto;\n}\n\n.set-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.set-table th {\n  padding: 12px 18px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-align: start;\n  text-transform: uppercase;\n}\n\n.set-table td {\n  padding: 14px 18px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n  font-size: 14px;\n}\n\n.set-table tr:last-child td {\n  border-bottom: 0;\n}\n\n.set-name {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.set-empty {\n  padding: 28px 18px;\n  color: #94a3b8;\n  text-align: center;\n}\n\n.intg {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.intg-head h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.intg-head p {\n  margin: 4px 0 0;\n  max-width: 640px;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.intg-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 6px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.intg-tabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.intg-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.intg-tab:hover {\n  background: #f1f5f9;\n}\n\n.intg-tab.is-active {\n  background: #0ea5e9;\n  color: #fff;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);\n}\n\n.intg-tab__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  color: #334155;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.intg-tab.is-active .intg-tab__count {\n  background: rgba(255, 255, 255, 0.22);\n  color: #fff;\n}\n\n.intg-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: min(240px, 100%);\n  height: 32px;\n  padding: 0 10px 0 32px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.intg-search svg {\n  position: absolute;\n  left: 10px;\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.intg-search input {\n  width: 100%;\n  border: 0;\n  outline: none;\n  background: transparent;\n  color: #0f172a;\n  font-size: 12px;\n}\n\n.intg-search input::placeholder {\n  color: #94a3b8;\n}\n\n.intg-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.intg-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: box-shadow 0.15s ease;\n}\n\n.intg-card:hover {\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);\n}\n\n.intg-card__accent {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 4px;\n  background: #cbd5e1;\n}\n\n.intg-card.is-connected .intg-card__accent {\n  background: #059669;\n}\n\n.intg-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px 20px 16px 24px;\n}\n\n.intg-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.intg-card__identity {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.intg-card__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.intg-card.is-connected .intg-card__icon {\n  border-color: #dcfce7;\n  background: #f0fdf4;\n  color: #059669;\n}\n\n.intg-card__identity h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n  line-height: 1.3;\n}\n\n.intg-card__protocol {\n  display: block;\n  margin-top: 2px;\n  color: #64748b;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  line-height: 1.35;\n}\n\n.intg-card__desc {\n  margin: 0;\n  color: #475569;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.intg-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.intg-status.is-on {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.intg-status__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #94a3b8;\n}\n\n.intg-status.is-on .intg-status__dot {\n  background: #059669;\n}\n\n.intg-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  padding: 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  color: #475569;\n}\n\n.intg-meta__item {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  min-width: 0;\n}\n\n.intg-meta__item > span {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.intg-meta__item strong {\n  overflow-wrap: anywhere;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.intg-meta__item strong.is-ok {\n  color: #059669;\n}\n\n.intg-meta__key {\n  max-width: 220px;\n}\n\n.intg-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 14px 20px 16px 24px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.intg-card__foot-note {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.intg-card__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-inline-start: auto;\n}\n\n.intg-ghost,\n.intg-manage {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.intg-ghost {\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #0f172a;\n  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.03);\n}\n\n.intg-ghost:hover {\n  background: #f8fafc;\n}\n\n.intg-manage {\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #0f172a;\n  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.03);\n}\n\n.intg-manage:hover {\n  background: #f8fafc;\n}\n\n.intg-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 48px 24px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  text-align: center;\n}\n\n.intg-empty__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  margin-bottom: 4px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #94a3b8;\n}\n\n.intg-empty h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.intg-empty p {\n  margin: 0;\n  max-width: 360px;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.intg-empty .intg-ghost {\n  margin-top: 8px;\n}\n\n@media (max-width: 900px) {\n  .intg-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .intg-search {\n    width: 100%;\n  }\n\n  .intg-card__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .intg-card__actions {\n    margin-inline-start: 0;\n  }\n\n  .intg-ghost,\n  .intg-manage {\n    flex: 1;\n    justify-content: center;\n  }\n}\n\n.dsch {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.dsch-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.dsch-title {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.dsch-title__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  margin-top: 2px;\n  border-radius: 8px;\n  background: #e0f2fe;\n  color: #0ea5e9;\n}\n\n.dsch-title h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.dsch-title p {\n  margin: 4px 0 0;\n  max-width: 640px;\n  color: #475569;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.dsch-add {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dsch-add:hover {\n  background: #f8fafc;\n}\n\n.dsch-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 14px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.dsch-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: min(280px, 100%);\n  flex: 1;\n}\n\n.dsch-field > span {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.dsch-field select {\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.dsch-field select:focus {\n  outline: none;\n  border-color: #0ea5e9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);\n}\n\n.dsch-panel {\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.dsch-panel__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 14px 18px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dsch-panel__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #0ea5e9;\n}\n\n.dsch-panel__title h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.dsch-panel__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  padding: 0 10px;\n  border: 1px solid #a7f3d0;\n  border-radius: 999px;\n  background: #ecfdf5;\n  color: #059669;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.dsch-panel__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #10b981;\n}\n\n.dsch-table-wrap {\n  overflow-x: auto;\n}\n\n.dsch-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.dsch-table th {\n  padding: 10px 14px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-align: start;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.dsch-table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #0f172a;\n  font-size: 13px;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.dsch-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.dsch-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.dsch-strong {\n  font-weight: 600;\n}\n\n.dsch-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 500;\n  color: #475569;\n}\n\n.dsch-day {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n}\n\n.dsch-day__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #cbd5e1;\n}\n\n.dsch-day__dot.is-on {\n  background: #0ea5e9;\n}\n\n.dsch-shift {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid #bfdbfe;\n  border-radius: 4px;\n  background: #eff6ff;\n  color: #0284c7;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.dsch-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.dsch-pill.is-on {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.dsch-table__actions {\n  text-align: end;\n}\n\n.dsch-edit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.dsch-edit:hover {\n  background: #f1f5f9;\n  color: #0ea5e9;\n}\n\n.dsch-empty {\n  padding: 36px 18px !important;\n  color: #94a3b8;\n  text-align: center;\n  white-space: normal !important;\n}\n\n.dsch-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 18px;\n  border-top: 1px solid #e2e8f0;\n  background: #fff;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.dsch-pager__controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dsch-pager__controls button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dsch-pager__controls button:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.dsch-pager__controls button:disabled {\n  color: #cbd5e1;\n  cursor: default;\n}\n\n@media (max-width: 900px) {\n  .dsch-field {\n    flex-direction: column;\n    align-items: stretch;\n    min-width: 100%;\n  }\n}\n\n.usr-head {\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.usr-crumb {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.usr-crumb__current {\n  color: #0ea5e9;\n  font-weight: 600;\n}\n\n.usr-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.usr-title h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.usr-title span {\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.usr-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 20px 0 16px;\n}\n\n.usr-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: min(320px, 100%);\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #94a3b8;\n}\n\n.usr-search input {\n  width: 100%;\n  border: 0;\n  outline: none;\n  background: transparent;\n  color: #0f172a;\n  font-size: 12px;\n}\n\n.usr-search:focus-within {\n  border-color: #0ea5e9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);\n}\n\n.usr-export {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.usr-export:hover {\n  background: #f8fafc;\n}\n\n.usr-export svg {\n  color: #64748b;\n}\n\n.usr-table tbody tr:hover td {\n  background: #f8fafc;\n}\n\n.usr-id {\n  color: #64748b;\n  font-variant-numeric: tabular-nums;\n}\n\n.usr-person {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.usr-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #bae6fd;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.usr-person strong,\n.usr-person em {\n  display: block;\n}\n\n.usr-person strong {\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.usr-person em {\n  margin-top: 2px;\n  color: #94a3b8;\n  font-size: 11px;\n  font-style: normal;\n}\n\n.usr-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 12px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.usr-pager div {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.usr-pager button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 28px;\n  padding: 0 6px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.usr-pager button:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n\n.usr-pager button.is-current {\n  background: #0ea5e9;\n  color: #fff;\n}\n\n.usr-pager button:disabled {\n  background: #f1f5f9;\n  color: #cbd5e1;\n  cursor: default;\n}\n\n.job-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.job-head h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.job-head p {\n  margin: 4px 0 0;\n  max-width: 560px;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.job-add {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  height: 36px;\n  padding: 0 14px;\n  border: 0;\n  border-radius: 8px;\n  background: #0ea5e9;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.job-add:hover {\n  background: #0284c7;\n}\n\n.job-add:disabled {\n  background: #94a3b8;\n  cursor: default;\n}\n\n.job-filters {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 20px 0 16px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.job-select {\n  position: relative;\n  width: 190px;\n}\n\n.job-select select {\n  width: 100%;\n  height: 36px;\n  padding: 0 28px 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 12px;\n  appearance: none;\n}\n\n.job-select svg {\n  position: absolute;\n  top: 10px;\n  inset-inline-end: 8px;\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.job-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.job-title i {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: #0ea5e9;\n}\n\n.job-role {\n  display: inline-flex;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.job-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 18px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.job-pager div {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.job-pager button,\n.job-pager .is-current {\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.job-pager button {\n  cursor: pointer;\n}\n\n.job-pager button:disabled {\n  color: #cbd5e1;\n  cursor: default;\n}\n\n.job-pager .is-current {\n  border-color: #0ea5e9;\n  background: #0ea5e9;\n  color: #fff;\n}\n\n.rxset {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.rxset-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.rxset-head h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.rxset-preview-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.rxset-preview-btn:hover {\n  background: #f8fafc;\n}\n\n.rxset-layout {\n  display: grid;\n  grid-template-columns: minmax(280px, 5fr) minmax(0, 7fr);\n  gap: 24px;\n  align-items: start;\n}\n\n.rxset-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.rxset-card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.rxset-card__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.rxset-card__head h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.rxset-card__lucide {\n  flex-shrink: 0;\n  color: #0284c7;\n}\n\n.rxset-margins {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.rxset-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rxset-field > span {\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.rxset-field small {\n  font-size: 11px;\n  line-height: 1.4;\n  color: #64748b;\n}\n\n.rxset-field__input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n}\n\n.rxset-field__input:focus-within {\n  border-color: #0284c7;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);\n}\n\n.rxset-field__input input {\n  width: 100%;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.rxset-field__input span {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.rxset-field__input--sm {\n  width: 80px;\n  flex-shrink: 0;\n  padding: 4px 10px;\n}\n\n.rxset-field__input--sm input {\n  text-align: right;\n}\n\n.rxset-font {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.rxset-font__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.rxset-font__row > span:first-child {\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.rxset-font__badge {\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.rxset-font__controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.rxset-font__controls input[type='range'] {\n  flex: 1;\n  height: 6px;\n  accent-color: #0ea5e9;\n  cursor: pointer;\n}\n\n.rxset-font p {\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.4;\n  color: #64748b;\n}\n\n.rxset-font__rule {\n  height: 1px;\n  background: #f1f5f9;\n}\n\n.rxset-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.rxset-reset,\n.rxset-save {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.rxset-reset {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n\n.rxset-reset:hover {\n  background: #f8fafc;\n}\n\n.rxset-save {\n  border: 0;\n  background: #0ea5e9;\n  color: #fff;\n}\n\n.rxset-save:hover:not(:disabled) {\n  background: #0284c7;\n}\n\n.rxset-save:disabled {\n  background: #94a3b8;\n  cursor: default;\n}\n\n.rxset-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px 20px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.rxset-preview__bar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rxset-preview__title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rxset-preview__dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #10b981;\n  flex-shrink: 0;\n}\n\n.rxset-preview__title h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.rxset-preview__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.rxset-preview__meta span:first-child {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.rxset-preview__meta span:last-child {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.rxset-preview__stage {\n  /* Paper preview uses physical LTR coords (margins + scale origin). */\n  direction: ltr;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 28px 24px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.rxset-ruler {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 560px;\n  gap: 8px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 10px;\n  color: #64748b;\n}\n\n.rxset-ruler__line {\n  position: relative;\n  flex: 1;\n  height: 1px;\n  margin: 0 4px;\n  background: #cbd5e1;\n}\n\n.rxset-ruler__line span {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  padding: 0 8px;\n  background: #f8fafc;\n  color: #475569;\n  white-space: nowrap;\n}\n\n.rxset-preview__tip {\n  margin: 0;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.rxset-sheet-scale {\n  position: relative;\n  direction: ltr;\n  overflow: hidden;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  background: #e2e8f0;\n}\n\n.rxset-sheet {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  background:\n    repeating-linear-gradient(\n      -45deg,\n      #f8fafc,\n      #f8fafc 6px,\n      #f1f5f9 6px,\n      #f1f5f9 12px\n    );\n  transition: padding 0.15s ease;\n  transform-origin: top left;\n}\n\n.rxset-sheet__body {\n  flex: 1;\n  min-height: 0;\n  padding: 8px;\n  background: #fff;\n  border: 1px dashed #cbd5e1;\n  box-sizing: border-box;\n}\n\n.rxset-sheet__body.is-rtl {\n  direction: rtl;\n  text-align: right;\n}\n\n.rxset-print-host {\n  position: absolute;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.rxset-print-root {\n  width: 210mm;\n  background: #fff;\n  color: #000;\n}\n\n.rxset-preview__stats {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n  max-width: 560px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  color: #64748b;\n}\n\n.rxset-preview__stats span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rxset-preview__stats i {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  background: #0284c7;\n}\n\n.rxset-preview__stats i.is-muted {\n  background: #cbd5e1;\n}\n\n@media (max-width: 1100px) {\n  .rxset-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .rxset-margins {\n    grid-template-columns: 1fr;\n  }\n\n  .rxset-head {\n    flex-direction: column;\n  }\n\n  .rxset-actions {\n    flex-direction: column-reverse;\n  }\n\n  .rxset-reset,\n  .rxset-save {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n.acct-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.acct-crumb {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.acct-crumb__current {\n  color: #0ea5e9;\n  font-weight: 600;\n}\n\n.acct-head h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.acct-save {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  gap: 6px;\n  width: fit-content;\n  height: 36px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 8px;\n  background: #0ea5e9;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.acct-save:hover:not(:disabled) {\n  background: #0284c7;\n}\n\n.acct-save:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.acct-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);\n  gap: 24px;\n  margin-top: 24px;\n}\n\n.acct-main,\n.acct-side {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.acct-card {\n  padding: 20px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.acct-card__head,\n.acct-onboard {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.acct-card__head {\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.acct-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: #0ea5e9;\n}\n\n.acct-card h2,\n.acct-onboard h2 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.acct-card__head p,\n.acct-onboard span,\n.acct-card small,\n.acct-panel p,\n.acct-onboard__body,\n.acct-onboard__empty {\n  margin: 2px 0 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.acct-fields {\n  display: grid;\n  gap: 16px;\n}\n\n.acct-fields--split {\n  grid-template-columns: 1fr 1fr;\n}\n\n.acct-card label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.acct-card label > span,\n.acct-email > span {\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.acct-input,\n.acct-input.ant-input-affix-wrapper {\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #0f172a;\n  font-size: 12px;\n  box-sizing: border-box;\n}\n\n.acct-input:focus,\n.acct-input.ant-input-affix-wrapper-focused {\n  background: #fff;\n  border-color: #0ea5e9;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);\n}\n\n.acct-input[readonly] {\n  color: #0f172a;\n}\n\n.acct-readonly {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f1f5f9;\n}\n\n.acct-readonly strong {\n  overflow: hidden;\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 500;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.acct-readonly em {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: #e2e8f0;\n  color: #475569;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.acct-email {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 16px;\n}\n\n.acct-email__row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.acct-ghost,\n.acct-onboard__action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.acct-ghost {\n  flex-shrink: 0;\n  align-self: flex-start;\n  width: fit-content;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #0ea5e9;\n}\n\n.acct-ghost:hover,\n.acct-onboard__action:hover {\n  background: #f0f9ff;\n}\n\n.acct-panel {\n  margin-top: 12px;\n  padding: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.acct-panel__title {\n  color: #0f172a;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.acct-panel .acct-input {\n  margin-top: 8px;\n  background: #fff;\n}\n\n.acct-strength {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.acct-strength__bars {\n  display: flex;\n  gap: 4px;\n  width: 160px;\n}\n\n.acct-strength__bars i {\n  flex: 1;\n  height: 6px;\n  border-radius: 999px;\n  background: #e2e8f0;\n}\n\n.acct-strength__bars.is-1 i:nth-child(-n + 1) { background: #f43f5e; }\n.acct-strength__bars.is-2 i:nth-child(-n + 2) { background: #f59e0b; }\n.acct-strength__bars.is-3 i:nth-child(-n + 3) { background: #0ea5e9; }\n.acct-strength__bars.is-4 i { background: #10b981; }\n\n.acct-strength em {\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.acct-strength__bars.is-1 + em { color: #f43f5e; }\n.acct-strength__bars.is-2 + em { color: #d97706; }\n.acct-strength__bars.is-3 + em { color: #0284c7; }\n.acct-strength__bars.is-4 + em { color: #10b981; }\n\n.acct-match {\n  color: #10b981 !important;\n  font-weight: 500;\n}\n\n.acct-error {\n  color: #e11d48 !important;\n}\n\n.acct-select {\n  position: relative;\n}\n\n.acct-select select {\n  width: 100%;\n  height: 36px;\n  padding: 0 32px 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #0f172a;\n  font-size: 12px;\n  appearance: none;\n}\n\n.acct-select svg {\n  position: absolute;\n  top: 9px;\n  inset-inline-end: 10px;\n  color: #64748b;\n  pointer-events: none;\n}\n\n.acct-onboard {\n  margin-bottom: 12px;\n}\n\n.acct-onboard__mark {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  background: #e0f2fe;\n  color: #0ea5e9;\n  flex-shrink: 0;\n}\n\n.acct-onboard span {\n  display: block;\n  color: #0ea5e9;\n  font-weight: 600;\n}\n\n.acct-onboard__body {\n  margin: 0 0 14px;\n}\n\n.acct-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 16px;\n  padding: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.acct-note svg {\n  flex-shrink: 0;\n  color: #0ea5e9;\n}\n\n.acct-onboard__action {\n  width: 100%;\n  border: 1px solid #bae6fd;\n  background: #f0f9ff;\n  color: #0284c7;\n}\n\n.acct-tours {\n  margin: 14px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.acct-tours li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 0;\n  border-top: 1px solid #f1f5f9;\n}\n\n.acct-tours strong,\n.acct-tours span {\n  display: block;\n}\n\n.acct-tours strong {\n  color: #0f172a;\n  font-size: 12px;\n}\n\n.acct-tours span {\n  margin-top: 2px;\n  color: #64748b;\n  font-size: 11px;\n}\n\n.acct-tours button {\n  flex-shrink: 0;\n  border: 0;\n  background: transparent;\n  color: #0284c7;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n@media (max-width: 1100px) {\n  .acct-grid,\n  .acct-fields--split,\n  .acct-email__row {\n    grid-template-columns: 1fr;\n  }\n\n  .acct-email__row,\n  .acct-head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
